import { ACTIONS_TYPES } from 'redux/helper';
import { service } from 'services';
import { basicCRUDAction, hotGetAction } from 'utils';

export default {
  getAll: async ({ dcId }) => hotGetAction({
    action: ACTIONS_TYPES.NAT_GATEWAY.GET_ALL,
    apiResult: service.natGateway.getAll({ dcId }),
    isRetrieveItems: true,
  }),

  create: async ({ dcId, properties }) => basicCRUDAction({
    action: ACTIONS_TYPES.NAT_GATEWAY.CREATE,
    apiResult: service.natGateway.create({ dcId, properties }),
  }),

  get: async ({ dcId, id }) => hotGetAction({
    action: ACTIONS_TYPES.NAT_GATEWAY.GET,
    apiResult: service.natGateway.get({ dcId, id }),
  }),

  update: async ({ dcId, id, properties }) => basicCRUDAction({
    action: ACTIONS_TYPES.NAT_GATEWAY.UPDATE,
    apiResult: service.natGateway.update({ dcId, id, properties }),
  }),

  delete: async ({ dcId, id }) => basicCRUDAction({
    action: ACTIONS_TYPES.NAT_GATEWAY.DELETE,
    apiResult: service.natGateway.delete({ dcId, id }),
  }),

  createRule: async ({ dcId, id, properties }) => basicCRUDAction({
    action: ACTIONS_TYPES.NAT_GATEWAY.CREATE_RULE,
    apiResult: service.natGateway.createRule({ dcId, id, properties }),
  }),

  updateRule: async ({
    dcId, id, properties, ruleId,
  }) => basicCRUDAction({
    action: ACTIONS_TYPES.NAT_GATEWAY.UPDATE_RULE,
    apiResult: service.natGateway.updateRule({
      dcId, id, properties, ruleId,
    }),
  }),

  deleteRule: async ({ dcId, id, ruleId }) => basicCRUDAction({
    action: ACTIONS_TYPES.NAT_GATEWAY.DELETE_RULE,
    apiResult: service.natGateway.deleteRule({ dcId, id, ruleId }),
  }),
};
